<template>
  <router-view/>
</template>

<style>
*{font-family: Helvetica; padding: 0; margin: 0; box-sizing: border-box;}
</style>